import axiosInstance from './axios';

const downloadFile = async (url, param) => {
    try {
        const response = await axiosInstance.get(url, {
            params: param,
            responseType: 'arraybuffer',
        });

        if (response.status === 200) {
            const contentDisposition = response.headers['content-disposition'];
            let filename = response.config.url.split('/').pop().split('?')[0];

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1]);
                }
            }

            const contentType =
                response.headers['content-type'] || 'application/octet-stream';
            const blob = new Blob([response.data], { type: contentType });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(link.href);
        } else {
            console.error(
                'Failed to download the file. Status:',
                response.status,
            );
        }
    } catch (error) {
        console.error('Error downloading file:', error);
    }
};

export default downloadFile;
